"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _components = _interopRequireDefault(require("./components"));

var _compiler = _interopRequireDefault(require("mson/lib/compiler"));

var Utils = /*#__PURE__*/function () {
  function Utils() {
    (0, _classCallCheck2.default)(this, Utils);
  }

  (0, _createClass2.default)(Utils, [{
    key: "getUIComponent",
    value: function getUIComponent(component) {
      var name = component.getClassName();
      var Component = _components.default[name];

      if (Component !== undefined) {
        return Component;
      } else if (_compiler.default.isCompiled(_compiler.default.getComponent(name))) {
        var Parent = Object.getPrototypeOf(component.constructor);
        return this.getUIComponent(new Parent());
      } else {
        // The React component wasn't found so check the MSON layer to see if we can automatically
        // determine the component from any MSON.
        var ancestorName = _compiler.default.getOldestCompiledAncestor(name);

        var Ancestor = _compiler.default.getComponent(ancestorName);

        return this.getUIComponent(new Ancestor());
      }
    }
  }]);
  return Utils;
}();

var _default = new Utils();

exports.default = _default;